export const TOKEN_META = {
  USDC:     { color: "#2775CA", bg: "#EBF3FB", letter: "U" },
  USDT:     { color: "#26A17B", bg: "#E8F7F3", letter: "T" },
  DAI:      { color: "#F5AC37", bg: "#FEF6E7", letter: "D" },
  ETH:      { color: "#627EEA", bg: "#EEF1FD", letter: "E" },
  WETH:     { color: "#627EEA", bg: "#EEF1FD", letter: "E" },
  WBTC:     { color: "#F7931A", bg: "#FEF3E7", letter: "W" },
  FRAX:     { color: "#333333", bg: "#F0F0F0", letter: "F" },
  ARB:      { color: "#28A0F0", bg: "#E8F5FE", letter: "A" },
  crvUSD:   { color: "#E8471A", bg: "#FDEDE8", letter: "C" },
  GHO:      { color: "#1A7A56", bg: "#E8F5EF", letter: "G" },
  LUSD:     { color: "#745DDF", bg: "#F0EDFD", letter: "L" },
  sUSD:     { color: "#1BAEF7", bg: "#E7F7FE", letter: "S" },
  "USDC.e": { color: "#2775CA", bg: "#EBF3FB", letter: "U" },
  PYUSD:    { color: "#0070E0", bg: "#E5F0FD", letter: "P" },
  USDS:     { color: "#1A7A56", bg: "#E8F5EF", letter: "S" },
  TUSD:     { color: "#002868", bg: "#E5EBF5", letter: "T" },
  GUSD:     { color: "#00DCFA", bg: "#E5FBFE", letter: "G" },
  MIM:      { color: "#9695F8", bg: "#F0F0FD", letter: "M" },
  DOLA:     { color: "#6B51D5", bg: "#EFEAFD", letter: "D" },
  "USD+":   { color: "#2775CA", bg: "#EBF3FB", letter: "+" },
  USDD:     { color: "#15A64A", bg: "#E5F5EA", letter: "D" },
  USDP:     { color: "#00845D", bg: "#E5F3EF", letter: "P" },
  alUSD:    { color: "#F5C728", bg: "#FEF8E5", letter: "A" },
  eUSD:     { color: "#627EEA", bg: "#EEF1FD", letter: "E" },
  RAI:      { color: "#36B37E", bg: "#E8F7F0", letter: "R" },
  USDbC:    { color: "#2775CA", bg: "#EBF3FB", letter: "U" },
  OP:       { color: "#D40010", bg: "#FDE5E7", letter: "O" },
  MATIC:    { color: "#6B35C8", bg: "#F0EAFD", letter: "M" },
  AAVE:     { color: "#B6509E", bg: "#F8EBF5", letter: "A" },
  CRV:      { color: "#E8471A", bg: "#FDEDE8", letter: "C" },
  BAL:      { color: "#1A7A56", bg: "#E8F5EF", letter: "B" },
  LINK:     { color: "#2A5ADA", bg: "#E9EFF9", letter: "L" },
  UNI:      { color: "#FF007A", bg: "#FFE5F0", letter: "U" },
  STETH:    { color: "#00A3FF", bg: "#E5F5FF", letter: "S" },
  stETH:    { color: "#00A3FF", bg: "#E5F5FF", letter: "S" },
  wstETH:   { color: "#00A3FF", bg: "#E5F5FF", letter: "W" },
  rETH:     { color: "#F6A140", bg: "#FEF5E7", letter: "R" },
  cbETH:    { color: "#0052FF", bg: "#E5EDFF", letter: "C" },
  CRVUSD:   { color: "#E8471A", bg: "#FDEDE8", letter: "C" },
  SCRVUSD:  { color: "#E8471A", bg: "#FDEDE8", letter: "S" },
  OUSD:     { color: "#1A82FF", bg: "#E5F0FF", letter: "O" },
  WMATIC:   { color: "#6B35C8", bg: "#F0EAFD", letter: "M" },
  TBTC:     { color: "#333333", bg: "#F0F0F0", letter: "T" },
  SUSDE:    { color: "#1A1A2E", bg: "#E8E8F0", letter: "S" },
  USDE:     { color: "#1A1A2E", bg: "#E8E8F0", letter: "U" },
  FRXUSD:   { color: "#333333", bg: "#F0F0F0", letter: "F" },
  FXUSD:    { color: "#E8471A", bg: "#FDEDE8", letter: "F" },
  CVX:      { color: "#3A3A3A", bg: "#F0F0F0", letter: "C" },
  OETH:     { color: "#1A82FF", bg: "#E5F0FF", letter: "O" },
  SFRXUSD:  { color: "#333333", bg: "#F0F0F0", letter: "S" },
  XAUT:     { color: "#C8A832", bg: "#FEF8E5", letter: "X" },
  PAXG:     { color: "#C8A832", bg: "#FEF8E5", letter: "P" },
  TEL:      { color: "#14C8EB", bg: "#E5FAFD", letter: "T" },
  PENDLE:   { color: "#14558F", bg: "#E5EEF5", letter: "P" },
  OHM:      { color: "#708B96", bg: "#EEF2F4", letter: "O" },
  WEETH:    { color: "#627EEA", bg: "#EEF1FD", letter: "W" },
  PUFETH:   { color: "#7B3FE4", bg: "#F0EAFD", letter: "P" },
  BOLD:     { color: "#0D7A4E", bg: "#E8F5EF", letter: "B" },
  GNO:      { color: "#009DFF", bg: "#E5F5FF", letter: "G" },
  ENS:      { color: "#5298FF", bg: "#E9F0FF", letter: "E" },
  EIGEN:    { color: "#1A0D5A", bg: "#E8E5F5", letter: "E" },
  ENA:      { color: "#7B61FF", bg: "#F0EDFF", letter: "E" },
  ONDO:     { color: "#1A1A2E", bg: "#E8E8F0", letter: "O" },
  FXS:      { color: "#333333", bg: "#F0F0F0", letter: "F" },
  SOL:      { color: "#9945FF", bg: "#F3EAFF", letter: "S" },
  PEPE:     { color: "#3F8F29", bg: "#E8F5E5", letter: "P" },
  SHIB:     { color: "#E84142", bg: "#FDE5E5", letter: "S" },
  GMX:      { color: "#2D42FC", bg: "#E9ECFF", letter: "G" },
  STG:      { color: "#333333", bg: "#F0F0F0", letter: "S" },
  MORPHO:   { color: "#2470FF", bg: "#E5EDFF", letter: "M" },
  COW:      { color: "#012D75", bg: "#E5EBF5", letter: "C" },
  EURC:     { color: "#2775CA", bg: "#EBF3FB", letter: "E" },
  SDAI:     { color: "#F5AC37", bg: "#FEF6E7", letter: "S" },
  SUSDS:    { color: "#1A7A56", bg: "#E8F5EF", letter: "S" },
  MUSD:     { color: "#333333", bg: "#F0F0F0", letter: "M" },
  ALUSD:    { color: "#F5C728", bg: "#FEF8E5", letter: "A" },
  SDOLA:    { color: "#6B51D5", bg: "#EFEAFD", letter: "S" },
  VIRTUAL:  { color: "#0052FF", bg: "#E5EDFF", letter: "V" },
  STMATIC:  { color: "#6B35C8", bg: "#F0EAFD", letter: "S" },
  MAI:      { color: "#D4001A", bg: "#FDE5E7", letter: "M" },
  EURS:     { color: "#2775CA", bg: "#EBF3FB", letter: "E" },
  CBBTC:    { color: "#0052FF", bg: "#E5EDFF", letter: "C" },
  FRXETH:   { color: "#333333", bg: "#F0F0F0", letter: "F" },
  SFRXETH:  { color: "#333333", bg: "#F0F0F0", letter: "S" },
  WSTETH:   { color: "#00A3FF", bg: "#E5F5FF", letter: "W" },
  RETH:     { color: "#F6A140", bg: "#FEF5E7", letter: "R" },
  COMP:     { color: "#00D395", bg: "#E5FAF3", letter: "C" },
  SNX:      { color: "#00D1FF", bg: "#E5FAFF", letter: "S" },
  MKR:      { color: "#1AAB9B", bg: "#E5F5F3", letter: "M" },
  LDO:      { color: "#00A3FF", bg: "#E5F5FF", letter: "L" },
  "ETH+":   { color: "#627EEA", bg: "#EEF1FD", letter: "+" },
  USDBC:    { color: "#2775CA", bg: "#EBF3FB", letter: "U" },
  BNB:      { color: "#F0B90B", bg: "#FEF8E5", letter: "B" },
  WBNB:     { color: "#F0B90B", bg: "#FEF8E5", letter: "B" },
  CAKE:     { color: "#1FC7D4", bg: "#E5FAFC", letter: "C" },
  BTCB:     { color: "#F7931A", bg: "#FEF3E7", letter: "B" },
  FDUSD:    { color: "#2775CA", bg: "#EBF3FB", letter: "F" },
  WSOL:     { color: "#9945FF", bg: "#F3EAFF", letter: "S" },
  RAY:      { color: "#2B6DEF", bg: "#E9EFFF", letter: "R" },
  MSOL:     { color: "#32D583", bg: "#E8F8F0", letter: "M" },
  JSOL:     { color: "#1BAEF7", bg: "#E7F7FE", letter: "J" },
  BONK:     { color: "#F5A623", bg: "#FEF6E7", letter: "B" },
  JUP:      { color: "#40D87A", bg: "#E8F8F0", letter: "J" },
  JITOSOL:  { color: "#32D583", bg: "#E8F8F0", letter: "J" },
  BSOL:     { color: "#9945FF", bg: "#F3EAFF", letter: "B" },
  USDC_SOL: { color: "#2775CA", bg: "#EBF3FB", letter: "U" },
  AVAX:     { color: "#E84142", bg: "#FDE5E5", letter: "A" },
  WAVAX:    { color: "#E84142", bg: "#FDE5E5", letter: "A" },
  JOE:      { color: "#E84142", bg: "#FDE5E5", letter: "J" },
  SUSHI:    { color: "#D93B8E", bg: "#FDE5F3", letter: "S" },
  VELO:     { color: "#FF0000", bg: "#FFE5E5", letter: "V" },
  AERO:     { color: "#0052FF", bg: "#E5EDFF", letter: "A" },
  // Memecoins
  DOGE:     { color: "#C2A633", bg: "#F8F3E5", letter: "D" },
  WDOGE:    { color: "#C2A633", bg: "#F8F3E5", letter: "D" },
  FLOKI:    { color: "#D4A843", bg: "#FAF4E7", letter: "F" },
  WIF:      { color: "#8B6914", bg: "#F3EDE5", letter: "W" },
  BRETT:    { color: "#0052FF", bg: "#E5EDFF", letter: "B" },
  MEME:     { color: "#9945FF", bg: "#F3EAFF", letter: "M" },
  TURBO:    { color: "#00D395", bg: "#E5FAF3", letter: "T" },
  MOG:      { color: "#8B4513", bg: "#F3EBE5", letter: "M" },
  NEIRO:    { color: "#FF69B4", bg: "#FFE5F0", letter: "N" },
  POPCAT:   { color: "#FF6B35", bg: "#FFF0E8", letter: "P" },
  BOME:     { color: "#32CD32", bg: "#E8F8E8", letter: "B" },
  MEW:      { color: "#FF1493", bg: "#FFE5F0", letter: "M" },
  DOG:      { color: "#A0522D", bg: "#F5ECE8", letter: "D" },
  MYRO:     { color: "#FFD700", bg: "#FFF8E0", letter: "M" },
  SLERF:    { color: "#228B22", bg: "#E8F3E8", letter: "S" },
  TRUMP:    { color: "#B8860B", bg: "#F5F0E5", letter: "T" },
  MELANIA:  { color: "#DB7093", bg: "#FBE8EF", letter: "M" },
  SPX:      { color: "#006400", bg: "#E5F0E5", letter: "S" },
  AI16Z:    { color: "#1E90FF", bg: "#E5F0FF", letter: "A" },
  GRIFFAIN: { color: "#7B68EE", bg: "#F0EDFF", letter: "G" },
  GOAT:     { color: "#8B7355", bg: "#F3EFE9", letter: "G" },
  PNUT:     { color: "#D2691E", bg: "#FAE8D8", letter: "P" },
  ACT:      { color: "#4169E1", bg: "#E8EDFC", letter: "A" },
  FARTCOIN: { color: "#90EE90", bg: "#E8FCE8", letter: "F" },
  PENGU:    { color: "#4682B4", bg: "#E8F0F5", letter: "P" },
  GIGA:     { color: "#DC143C", bg: "#FBE5E8", letter: "G" },
  WOJAK:    { color: "#F0E68C", bg: "#FDFBE8", letter: "W" },
  CHAD:     { color: "#0000CD", bg: "#E5E5FA", letter: "C" },
  BASED:    { color: "#0052FF", bg: "#E5EDFF", letter: "B" },
  TOSHI:    { color: "#1E90FF", bg: "#E5F0FF", letter: "T" },
  // 2025-2026 trending memecoins
  M:        { color: "#FF4500", bg: "#FFE8E0", letter: "M" },
  PIPPIN:   { color: "#7B68EE", bg: "#F0EDFF", letter: "P" },
  YZY:      { color: "#1A1A1A", bg: "#E8E8E8", letter: "Y" },
  CHEEMS:   { color: "#D4A843", bg: "#FAF4E7", letter: "C" },
  MOODENG:  { color: "#FF69B4", bg: "#FFE5F0", letter: "M" },
  DEGEN:    { color: "#A36EFD", bg: "#F0EAFF", letter: "D" },
  DOGS:     { color: "#C2A633", bg: "#F8F3E5", letter: "D" },
  BABYDOGE: { color: "#F5A623", bg: "#FEF6E7", letter: "B" },
  PEANUT:   { color: "#D2691E", bg: "#FAE8D8", letter: "P" },
  AIXBT:    { color: "#00D4FF", bg: "#E5FAFF", letter: "A" },
  ZEREBRO:  { color: "#6A0DAD", bg: "#F0E5FA", letter: "Z" },
  ARC:      { color: "#FF6347", bg: "#FFE8E5", letter: "A" },
  ELIZA:    { color: "#DA70D6", bg: "#FAE8F8", letter: "E" },
  SIREN:    { color: "#20B2AA", bg: "#E5F5F3", letter: "S" },
  DUCKY:    { color: "#FFD700", bg: "#FFF8E0", letter: "D" },
  BAN:      { color: "#FFE135", bg: "#FFFBE5", letter: "B" },
  COMEDIAN: { color: "#808080", bg: "#F0F0F0", letter: "C" },
  HIGHER:   { color: "#00FF7F", bg: "#E5FFE8", letter: "H" },
  TYBG:     { color: "#0052FF", bg: "#E5EDFF", letter: "T" },
};

export const PROTOCOL_COLORS = {
  "Curve":        "#E8471A",
  "Uniswap V3":   "#E0006E",
  "Balancer":     "#1A7A56",
  "PancakeSwap":  "#1FC7D4",
  "Raydium":      "#2B6DEF",
  "Orca":         "#FFD15C",
  "Kamino":       "#32D583",
  "Uniswap V4":   "#E0006E",
  "Aerodrome":    "#0052FF",
  "Velodrome":    "#FF0000",
  "SushiSwap":    "#D93B8E",
  "Trader Joe":   "#E84142",
  "Camelot":      "#FFAF1D",
};

export const CHAIN_COLORS = {
  Ethereum: "#5470D4",
  Arbitrum: "#1A8ED4",
  Optimism: "#D40010",
  Base:     "#0040D4",
  Polygon:  "#6B35C8",
  BSC:      "#F0B90B",
  Solana:    "#9945FF",
  Avalanche: "#E84142",
};

export const RISK_MAP = {
  LOW:  { color: "#0D7A4E", bg: "#E8F8F2", border: "#A8DEC8" },
  MED:  { color: "#8A6A00", bg: "#FFF8E0", border: "#E0CC70" },
  HIGH: { color: "#B8001A", bg: "#FFF0F2", border: "#F0A0A8" },
};
